import React, { useRef, useLayoutEffect, useState } from "react";
import Progressbar from "./Progress_bar";
import { Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { Box, Button, HStack, Text } from "@chakra-ui/react";

const Index = (props) => {
  const data1 = [
    { y: 15.75, label: "On playgold.io Staking Pool", color: "#e7b300 " },
    { y: 40.88, label: "On Dining Out", color: "#e7b300 " },
    { y: 60, label: "In Peer to Peer Transactions", color: "#e7b300 " },
  ];
  const data2 = [
    { y: 10.75, label: "As Salary", color: "#e7b300 " },
    { y: 25.88, label: "From Ecommerce Store", color: "#e7b300 " },
    { y: 60, label: "From playgold.io Staking Pools", color: "#e7b300 " },
  ];

  const [username, setUsername] = useState();
  //const [currentUser, setCurrentUser] = useState();

  const navigate = useNavigate();

 /* useEffect(() => {
    const validateLogin = async () => {
      if (!localStorage.getItem("chat-app-current-user")) {
        navigate("/login");
      } else {
        console.log("Login validated");
        const data = JSON.parse(localStorage.getItem("chat-app-current-user"));
        setUsername(data.username);
        console.log(username);
      }
    };
    validateLogin();
  }, []);

  /*useEffect(()=>{
    const kycStatus = async() => {
      if (!localStorage.getItem("chat-app-current-user")){
        navigate("/login")
      }
      const data = JSON.parse(localStorage.getItem("chat-app-current-user"))
      if (data.hasCompletedKyc === false){
        navigate("/form")
      }
    }
    kycStatus()
  })*/

  return (
    <>
      <Box>
        <HStack>
          <Text ml="60" mt="20">
            Wallet Balance: $7
          </Text>
          <Button colorScheme="messenger" rounded={"md"}>
            Recharge
          </Button>
        </HStack>
      </Box>
      <section>
        <div className="container-fluid">
          <div className="row  Average-chart pb-5">
            <div className="col-md-12">
              <div className="charts-sec">
                <div className="chart-1 chartL">
                  <div className="barlines">
                    <div className="pie-chart">
                      <h4>Top Spends</h4>
                      <div className="piemob">
                        {data1.map((event, index) => {
                          return (
                            <Progressbar
                              key={index}
                              bgcolor={event.color}
                              progress={event.y}
                              height={5}
                              name={event.label}
                            />
                          );
                        })}
                      </div>
                    </div>
                    <div className="pie-chart">
                      <h4>Top Earning</h4>
                      <div className="piemob">
                        {data2.map((event, index) => {
                          return (
                            <Progressbar
                              key={index}
                              bgcolor={event.color}
                              progress={event.y}
                              height={5}
                              name={event.label}
                            />
                          );
                        })}
                      </div>
                    </div>
                  </div>
                  <div className="mt-5">
                    <div className="">
                      <div className="buttonclass">
                        <button type="button">YOUR STATS AT A GLANCE</button>
                      </div>
                      <h2>Spends this month</h2>
                      <p>Here is your top 3 spend categories this month</p>
                      <div className="list">
                        <div className="listinner">
                          <p className="iconSymbol">{"~"}</p>
                          <p>$500 put into Paygold.io staking pools</p>
                        </div>
                        <div className="listinner">
                          <p className="iconSymbol">{"~"}</p>
                          <p>$250 on Dining Out</p>
                        </div>
                        <div className="listinner">
                          <p className="iconSymbol">{"~"}</p>
                          <p>$100 in Peer to Peer Transactions</p>
                        </div>
                      </div>
                    </div>
                    <div className="mt-3">
                      <h2>Earnings this month</h2>
                      <p>Here is your top 3 income categories this month</p>
                      <div className="list">
                        <div className="listinner">
                          <p className="iconSymbol">{"~"}</p>
                          <p>$4000 as Salary</p>
                        </div>
                        <div className="listinner">
                          <p className="iconSymbol">{"~"}</p>
                          <p>$750 from your ecommerce store</p>
                        </div>
                        <div className="listinner">
                          <p className="iconSymbol">{"~"}</p>
                          <p>$50 from Paygold.io staking pools</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="chart-1 chartR"
                  style={{ backgroundColor: "#0000" }}
                >
                  <div className="chart-main">
                    <div className="row chart-head">
                      <div className="chart-second-head">
                        <h4>Profile</h4>
                      </div>
                      <div className="profileImage">
                        <img src="img/pancake 1.png" alt="" />
                      </div>
                      <div className="editprofile">
                        <button type="button">Edit Profile Info</button>
                      </div>
                      <div className="text-center">
                        <h3>{username}</h3>
                        <p>@{username}</p>
                      </div>
                      <div className="cardimg">
                        <img src="img/card-demo.png" alt="" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Index;
